/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {IFeatureBetEventData} from "../../inactiveRow/BookOfShadowsInactiveRowController";
import {BookOfShadowsGameModuleConfig} from "../../BookOfShadowsGameModuleConfig";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";

export class SpinStart implements GameRoundPresentation {
    public static readonly SPIN_STARTED_EVENT: string = "spinStartSpinStartedEvent";
    stagger?: number;
    abortStagger?: number;
    private _isFeatureBuyClicked: boolean = false;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;

        this.addEventListeners();
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): Timeline | null {
        const tl: TimelineLite = new TimelineLite(),
            delayForFeatureBuy: number = 0.1;

        tl.add(() => BookOfShadowsGameConfig.instance.LUCKY_LOCKS_ALLOWED_VIA_BET = true);

        if (this._isFeatureBuyClicked) {
            tl.add(TweenLite.to(() => {
            }, delayForFeatureBuy, {}));
        }

        tl.add(() => {
            BookOfShadowsGameModuleConfig.symWinAnims.stopAllAnimation();

            // #165
            BookOfShadowsGameModuleConfig.gameTutorial.spinStarted = true;
            TweenLite.delayedCall(0.2, () => {
                BookOfShadowsGameModuleConfig.gameTutorial.spinStarted = false;
            });

            BookOfShadowsGameModuleConfig.reelLockController.displayReelLockCosts(true);

            EventHandler.dispatchEvent(new GameEvent(SpinStart.SPIN_STARTED_EVENT));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        });

        return tl;
    }

    /**
     * @description To register the event listeners.
     */
    private addEventListeners(): void {
        EventHandler.addEventListener(this, BalanceEvent.BET, (event: GameEvent) => this.onBet(event.params[0]));
    }

    /**
     * @description When we hit a bet request.
     * @param bet
     */
    private onBet(bet: IFeatureBetEventData): void {
        const featureName: string | undefined = bet.featureName;

        this._isFeatureBuyClicked = (bet.type === APIBetType.FEATURE_BET && featureName.indexOf("FREESPIN") > -1);
    }
}